import React from "react";
import styled from "styled-components";
import { FaCheckSquare } from "react-icons/fa";

const WhyScrumanac = ({ whyData }) => {
  return (
    <WhyScrumana>
      <WhyScrumanacContent>
        <ModelItemContentTitle>
          <h3>Why Scrumanac dedicated team?</h3>
        </ModelItemContentTitle>
        {whyData.map((item) => (
          <WhyScrumanacItem>
            <WhyScrumanacItemLeft>
              <StyledSquare size={40} />
            </WhyScrumanacItemLeft>
            <WhyScrumanacItemRight>
              <WhyScrumanacTitle>
                <h2>{item.title}</h2>
              </WhyScrumanacTitle>
              <WhyScrumanacRightContent>
                <p>{item.text}</p>
              </WhyScrumanacRightContent>
            </WhyScrumanacItemRight>
          </WhyScrumanacItem>
        ))}
      </WhyScrumanacContent>
    </WhyScrumana>
  );
};

const WhyScrumana = styled.div`
  background: #fff;
  padding-top: 25px;
  @media (max-width: 980px) {
    width: 100%;
  }
`;

const WhyScrumanacContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  @media (max-width: 980px) {
    width: 100%;
    padding: 0.5rem;
  }
`;
const WhyScrumanacItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 10px;
  @media (max-width: 970px) {
    margin-bottom: 30px;
  }
`;
const WhyScrumanacItemRight = styled.div`
  width: 80%;
  & h2 {
    font-weight: bold;
    font-size: 15px;
  }
  @media (max-width: 970px) {
    width: 100%;
  }
`;
const WhyScrumanacItemLeft = styled.div`
  flex-basis: 20%;
  padding-left: 25px;
  @media (max-width: 970px) {
    display: none;
  }
`;
const WhyScrumanacTitle = styled.div`
  margin-bottom: 20px;
  @media (max-width: 970px) {
    text-align: center;
  }
`;

const WhyScrumanacRightContent = styled.div`
  width: 100%;
  font-size: 15px;
  @media (max-width: 970px) {
    padding: 5px;
    display: flex;
    justify-content: center;
    font-size: 1rem;
    font-weight: 400;
  }
`;

const ModelItemContentTitle = styled.div`
  font-family: 'Archivo';
  font-weight: 700;
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 0.95;
  color: #3d3d3d;
  margin-bottom: 1.8rem;
  & h3 {
    font-size: inherit;
    font-weight: inherit;
    margin-bottom: 0;
    line-height: inherit;
  }
  @media (max-width: 970px) {
    text-align: center;
  }
`;

const StyledSquare = styled(FaCheckSquare)`
  color: #0066b2;
`;

export default WhyScrumanac;
